import { EventName } from "@/api/event/common";
import { SocketMgr } from "@/Core/net/socket/SocketMgr";
import { sys } from "@/Core/utils/system";
import { resetSessionState } from "@/features/redux/store";
import { useGlobalState } from "@/store/commonStore";
import EventMgr from "@/utils/EventMgr";
import useDialog from "@/utils/useDialog";
import { useCallback, useRef } from "react";
import { useDispatch } from "react-redux";
import { useSWRConfig } from "swr";

const isAuthenticatedCacheKey = (key: unknown): key is string => {
  if (typeof key !== "string") {
    return false;
  }

  return key.split("|")[2] === "1";
};

/**
 * 服务端强制退出的唯一执行入口。
 *
 * 先同步停掉实时链路和凭据，再清理会话态，最后用 replace 完整卸载当前页面。
 * 完整卸载可以确保第三方游戏 iframe、组件局部状态和各类弹窗不会残留到下一位用户。
 */
export const useForcedLogout = () => {
  const handledRef = useRef(false);
  const dispatch = useDispatch();
  const { cache } = useSWRConfig();
  const { close } = useDialog();
  const { setIsLogin, setToken, setTokenTime } = useGlobalState();

  return useCallback(() => {
    if (handledRef.current) {
      return;
    }
    handledRef.current = true;

    EventMgr.getInstance().dispatchEvent(EventName.FORCE_LOGOUT);
    SocketMgr.close();

    localStorage.removeItem("authToken");
    localStorage.removeItem("tokenTime");
    sys.token = "";
    setToken("");
    setTokenTime("");
    setIsLogin(false);

    for (const key of cache.keys()) {
      if (isAuthenticatedCacheKey(key)) {
        cache.delete(key);
      }
    }

    close();
    dispatch(resetSessionState());

    window.location.replace(new URL("/home", window.location.href).href);
  }, [
    cache,
    close,
    dispatch,
    setIsLogin,
    setToken,
    setTokenTime,
  ]);
};
